import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string , ref} from 'yup';
import { UpdatePasswordDialogValues } from 'src/models/UpdatePasswordDialog.model';
import { useChangeTrainerPasswordMutation } from 'src/services/TrainerServices';
import { showToast } from 'src/utils/showToaster';
import ChangeTrainerPassword from './ChangeTrainerPassword';



type Props = {
  onClose: () => void;
  trainerId:string ;
  setTrainerId:any;
  
};

const ChangeTrainerPasswordWrapper = ({ onClose , setTrainerId , trainerId  }: Props) => {

    const[updatePassword] = useChangeTrainerPasswordMutation()

  // Form Initial Values
  const initialValues: UpdatePasswordDialogValues = {
    newPassword:'' ,
    confrimPassword:'' 
  };

  // Validation Schema
  const validationSchema = object().shape({
    newPassword: string().trim().min(4, 'password must be at least 5 characters long.').required('password is required'),
    confrimPassword: string().trim().min(4, 'password must be at least 5characters long.').required('confirm password is required')
        .oneOf([ref("newPassword")], "Passwords do not match"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UpdatePasswordDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<UpdatePasswordDialogValues>
  ) => { 
    const formattedValues ={
        password:values?.newPassword,
        confirmPassword:values?.confrimPassword
    }
    updatePassword({
        body :formattedValues ,
        id:trainerId ,
    }).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            setTrainerId('')
            onClose()
            resetForm();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ChangeTrainerPassword formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ChangeTrainerPasswordWrapper;